import { ILayoutToolsAction } from '@base/@types/components/Layout/Tools'
import { IActionsHeaderOtb } from '@base/@types/providers/Otb/PlanProvider'

export const actionsHeaderOtb = ({
  data,
  headers,
  toggleColumn,
  parsePlanOtbData
}: IActionsHeaderOtb) => {
  return [
    {
      type: 'export',
      exports: [
        {
          type: 'excel',
          entity: 'salesKpi',
          data,
          headers,
          parser: parsePlanOtbData
        }
      ]
    },
    {
      type: 'columns',
      data: headers,
      onToggleColumn: toggleColumn
    }
  ] as ILayoutToolsAction[]
}
